import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Typography, Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const TypographyTextNav = styled(Typography)(
    ({ theme }: ParamsStyle) => `
        font-size: .9375rem;
        font-weight: 400;

        strong {
            font-size: .9375rem;
            color: ${theme?.palette.secondary.main};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            strong {
                font-size: 1.125rem;
            }
        }
`);

export const ContainerCards = styled.div(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        height: 5.93rem;
        margin-top: 1.31rem;
        justify-content: space-between;
        
        @media(min-width: ${theme?.breakpoints.values.md}px) {
            height: 8.75rem;
            margin-top: 2rem;
        }
`);

export const Card = styled(Box)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        align-items: center;
        border-radius: .5rem;
        flex-direction: column;
        justify-content: center;
        width: calc(33% - .3rem);

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            border-radius: .75rem;
            width: calc(25% - 1.5rem);
        }
`);
